import service from '@/services/teamMembers';

export default {
  loadTeamMembers: ({ commit, state }) => {
    commit('setTeamMembersLoading', true);
    service
      .getTeamMembers(state.teamMembers.pagination)
      .then(response => commit('loadTeamMembersSuccess', response))
      //eslint-disable-next-line no-console
      .catch(err => console.error(err));
  },
  removeTeamMember: ({ dispatch }, invitationId) => {
    service
      .removeTeamMember(invitationId)
      .then(() => {
        dispatch('loadTeamMembers');
      })
      .catch(() => {});
  },
  inviteTeamMember: ({ dispatch }, invitationId) => {
    service
      .inviteTeamMember(invitationId)
      .then(() => {
        dispatch('loadTeamMembers');
      })
      .catch(() => {});
  },
  setTeamMembersPagination({ commit }, payload) {
    commit('setTeamMembersPagination', payload);
  },
};
